import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { STChange, STColumn, STData, STScroll } from '@app/interfaces/sys/st';
import { ApplicationService } from '@services/lm/application.service';
import { Application } from '@app/interfaces/lm/application';
import { ApplicationDetailComponent } from './components/application-detail/application-detail.component';

@Component({
    selector: 'app-application',
    templateUrl: './application.component.html',
})
export class ApplicationComponent implements OnInit, OnChanges {
    @Input() type = '';
    @Input() scroll: STScroll = {};
    @ViewChild('applicationDetail') applicationDetail: ApplicationDetailComponent | undefined;
    loading = false;
    columns: STColumn[] = [
        {
            title: 'Tester',
            index: 'testerName',
            sort: true
        },
        {
            title: 'Project name',
            index: 'projectName',
            type: 'link',
            click: (record: STData) => {
                console.log('record', record);
                this.router.navigate(['/project/project-task', record.id]);
            },
            sort: true
        },
        {
            title: 'Start Date',
            index: 'startDate',
            type: 'date',
            dateFormat: 'yyyy-MM-dd',
            sort: true
        },
        {
            title: 'End Date',
            index: 'endDate',
            type: 'date',
            dateFormat: 'yyyy-MM-dd',
            sort: true
        },
        {
            title: 'Action',
            render: 'action',
            className: 'remove-padding',
        },
    ];
    data: Application[] = [];
    page = 0;
    size = 10;
    total = 0;
    params: {
        [key: string]: string
    } = {};

    constructor(private applicationService: ApplicationService, private router: Router) {}

    ngOnInit(): void {
        this.fetchData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.type) {
            this.fetchData();
        }
    }

    handleChange(event: STChange): void {
        const { type, pi, ps } = event;
        if (event.type === 'sort') {
            const params = {
                sort: event.sort
            };
            this.handleRefresh(params);
        }

        if (type === 'pi') {
            this.page = pi - 1;
            this.fetchData();
        }

        if (type === 'ps') {
            this.size = ps;
            this.fetchData();
        }
    }

    handleRefresh(params: object = {}): void {
        this.page = 0;
        this.params = {
            ...this.params,
            ...params
        };
        this.fetchData();
    }

    async fetchData(): Promise<void> {
        try {
            if (this.page !== 0 && Math.ceil(this.total / this.size) <= this.page) {
                return;
            }
            this.loading = true;
            const query = {
                ...this.params,
                page: this.page,
                size: this.size,
                type: this.type,
            };
            const { content, totalElements } = await this.applicationService.find(query);
            this.data = content;
            this.total = totalElements;
        } finally {
            this.loading = false;
        }
    }

    handleDetail(row: Application): void {
        console.log('handleDetail', row);
        this.applicationDetail?.open(row);
    }
}
